var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 903.13,
    height: 880,
    viewBox: "0 0 903.13 880",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-752.694 -278.791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M727.7,570.4c0-113.138,91.717-381.61,204.855-381.61s204.855,268.472,204.855,381.61-91.717,204.855-204.855,204.855S727.7,683.54,727.7,570.4Z",
    transform: "translate(509.386 90)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.994,999.567a1.684,1.684,0,0,1-1.684-1.684V291.609a1.684,1.684,0,0,1,3.369,0V997.883A1.684,1.684,0,0,1,849.994,999.567Z",
    transform: "translate(591.943 159.224)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.941,406.186a1.679,1.679,0,0,1-1.191-.494l-81.082-81.081a1.684,1.684,0,1,1,2.382-2.382l81.081,81.081a1.684,1.684,0,0,1-1.191,2.875Z",
    transform: "translate(558.996 180.998)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.994,511.745a1.685,1.685,0,0,1-1.191-2.875L984.588,373.084a1.684,1.684,0,0,1,2.382,2.382L851.185,511.252a1.679,1.679,0,0,1-1.191.493Z",
    transform: "translate(591.943 215.806)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.054,518.565c26.876-6.075,57.323,14.947,58.267,43.169.265,7.938-2.061,16.274-8.169,21.675-5.043,4.458-12.547,6.707-19.066,4.528-12.545-4.193-13.215-21.674-6.485-31.01,9.112-12.642,27.163-14.8,41.487-13.3,17.512,1.838,34.156,9.517,48.123,20.041,27.96,21.069,45.764,53.361,60.174,84.56A426.337,426.337,0,0,1,720.321,748.59q1.219,6.527,2.233,13.089a2.545,2.545,0,0,0,3.133,1.72,2.592,2.592,0,0,0,1.72-3.133,431.969,431.969,0,0,0-32.4-109.595c-15.089-33.812-34.111-68.884-64.372-91.448-15.085-11.248-32.9-19.076-51.751-20.75-15.871-1.409-34.664,1.948-44.533,15.752-7.786,10.889-7,28.987,5.052,36.571,6.623,4.17,15.039,3.682,21.917.441a28.069,28.069,0,0,0,14.8-18.346c4.278-15.674-2.218-32.628-13.355-43.832a56.127,56.127,0,0,0-39.5-16.613,49.739,49.739,0,0,0-10.62,1.266c-3.173.717-1.755,5.569,1.413,4.853Z",
    transform: "translate(440.882 311.534)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.484,716.829l-16.7-28.515,20.594-12.062,16.7,28.514h0a11.933,11.933,0,0,1-20.594,12.062Z",
    transform: "translate(488.061 423.655)",
    fill: "#002bfe"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.687,
    cy: 14.687,
    r: 14.687,
    transform: "translate(1014.635 1051.84)",
    fill: "#002bfe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.846,716.829l-16.7-28.515,20.593-12.062,16.7,28.514a11.933,11.933,0,0,1-20.593,12.063Z",
    transform: "translate(514.319 423.655)",
    fill: "#002bfe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.572,686.683a31.245,31.245,0,0,1,31.21-31.21h98.8a13.207,13.207,0,0,1,13.191,13.192v11.242a38.028,38.028,0,0,1-37.986,37.986h-74A31.245,31.245,0,0,1,558.572,686.683Z",
    transform: "translate(473.542 409.432)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.1,715.952V682.906h23.866v33.045a11.933,11.933,0,1,1-23.866,0Z",
    transform: "translate(482.8 428.209)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.21,715.952V682.906h23.866v33.045a11.933,11.933,0,1,1-23.866,0Z",
    transform: "translate(510.941 428.209)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.338,626.155a12.055,12.055,0,0,1,18.8,15.1l-19.815,24.671-18.8-15.1Z",
    transform: "translate(532.211 402.384)",
    fill: "#002bfe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.861,667.928l15.874-19.765a23.244,23.244,0,0,1,32.64-3.563l4.96,3.983a27.712,27.712,0,0,1,4.249,38.916L681.5,703.783a8.7,8.7,0,0,1-12.22,1.334L638.2,680.148A8.7,8.7,0,0,1,636.861,667.928Z",
    transform: "translate(523.959 409.211)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.7,623.641A8.288,8.288,0,1,1,691.62,634.02l-22.174,27.608-12.923-10.379Z",
    transform: "translate(532.211 401.96)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.763,656.162l34.07,27.363a12.055,12.055,0,1,1-15.1,18.8l-34.07-27.363Z",
    transform: "translate(525.381 415.587)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.086,
    cy: 2.825,
    rx: 5.086,
    ry: 2.825,
    transform: "translate(1208.932 1117.38) rotate(-51.23)",
    fill: "#002bfe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130.9,712.393H230.38a1.74,1.74,0,0,1,0-3.369H1130.9a1.74,1.74,0,0,1,0,3.369Z",
    transform: "translate(523.617 446.086)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(775.808 588.397)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.174, 0.985, -0.985, -0.174, 198.298, 136.76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.075,30.812,11.77,50.971,0,37.947,22.3,17.789a18.427,18.427,0,0,1,6.288-12.78c6.953-6.283,16.8-6.713,22-.959s3.78,15.512-3.173,21.8a18.427,18.427,0,0,1-13.35,4.967h0Z",
    transform: "translate(62.154 0)",
    fill: "#e8989b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,66.053,76.788,0l19.94,23.05-87.714,85.9",
    transform: "translate(0 15.6)",
    fill: "#002bfe"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M178.9,218.849l-11.136,44,76.894-.95-8.8-40.208Z",
    transform: "translate(-112.243 -40.701)",
    fill: "#e8989b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.977,377.223l-16.695,73.039L114.556,596.495l14.24,2.848L226.669,381.4Z",
    transform: "translate(-109.545 -48.729)",
    fill: "#e8989b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.368,392.839,229.2,461.122l45.287,137.2,18.986-4.747-41.044-236.5Z",
    transform: "translate(-113.794 -47.707)",
    fill: "#e8989b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.772,247.612s-34.33,89.616-28.07,188.609c0,0,50.613,56.812,131.92,4.222L241.152,242.456l-70.379,5.156h0Z",
    transform: "translate(-110.933 -41.897)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.911,624.949a6.343,6.343,0,0,1-2.623-4.447c-.121-1.843.79-3.82,2.706-5.876.046-.592.642-7.923,1.965-9.236-.111-.392-.786-2.994.321-4.684a3.208,3.208,0,0,1,2.5-1.375l.049-.005.025.044c.032.057,3.256,5.729,8.108,6.227,2.781.285,5.566-1.164,8.275-4.309.1-.232.864-4.061,1.358-6.6l.02-.1,26.431,14.066,15.45,4.329a4.574,4.574,0,0,1,.749,8.493l-7.489,3.645a23.185,23.185,0,0,1-10.091,2.328H119.042a11.254,11.254,0,0,1-7.13-2.5h0Z",
    transform: "translate(-109.277 -59.748)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.911,624.949a6.343,6.343,0,0,1-2.623-4.447c-.121-1.843.79-3.82,2.706-5.876.046-.592.642-7.923,1.966-9.236-.111-.392-.786-2.994.321-4.684a3.208,3.208,0,0,1,2.5-1.375l.049-.005.025.044c.032.057,3.256,5.729,8.108,6.227,2.782.285,5.566-1.164,8.275-4.309.1-.232.864-4.061,1.358-6.6l.02-.1,26.431,14.066,15.45,4.329a4.574,4.574,0,0,1,.749,8.493l-7.489,3.645a23.189,23.189,0,0,1-10.09,2.328H278.043a11.254,11.254,0,0,1-7.13-2.5Z",
    transform: "translate(-117.338 -59.748)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.132,73.344a31.015,31.015,0,1,1,40.308,29.6l-6,39.625-30.565-25.471A77,77,0,0,0,205.023,99.2a30.986,30.986,0,0,1-13.891-25.852Z",
    transform: "translate(-113.428 -31.752)",
    fill: "#e8989b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.384,107.251,226.915,130.6l16.861,29.773a41.655,41.655,0,0,1,4.651,28.43l-7.747,40.078H159.907l12.763-83.615a70.3,70.3,0,0,1,11.88-29.674l5.835-8.342Z",
    transform: "translate(-111.845 -35.043)",
    fill: "#002bfe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.349,76.759S1.8,87.748,15.216,88.107l27.219.728s-23.01-56-13.549-49.688S63.578,19,63.578,19l7.445,13.962s17.785-6.44-1.925-22.212c0,0-23.518-18.183-48.485-7.263S.353,76.757.353,76.757h0Z",
    transform: "translate(74.828 0) rotate(9)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.329,325.9l-.652-30.057,17.549-.38.652,30.057a18.427,18.427,0,0,1,5.552,13.117c.2,9.369-5.918,17.1-13.671,17.269s-14.2-7.291-14.408-16.66A18.426,18.426,0,0,1,198.329,325.9Z",
    transform: "translate(-113.54 -44.584)",
    fill: "#e8989b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.008,169.057V314.746H191.531l-9.008-144.458",
    transform: "translate(-112.992 -38.176)",
    fill: "#002bfe"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.4394a7c64d9054a4373b2fb449b65639.svg";
export { ForwardRef as ReactComponent };